// Include jQuery
const $ = require('jquery');

// jQuery Definitionen
window.jQuery = $;
window.$ = $;

// Include Vendors
require('tooltipster');

// Include Helpers
require('../vendor/boostrap.bundle.min');

// Includes
require('./helper');

// Document Ready
$(function() {

});

// KeyDown
$(document).on('keydown', function(e) {
  if (e.key === 'Escape') {
    let popupWrap = [];
    $('body').find('.modal').each(function() {
      popupWrap.push($(this));
    });

    const lastItem = popupWrap.pop();

    // Beim Drücken von ESC das letzte Popup schließen
    if (typeof lastItem !== 'undefined' && lastItem.length) {
      const popUpWrap = $('body .modal');
      popUpWrap.last().remove();
      if ($('body .modal ').length === 0) {
        $('body .modal-backdrop').remove();
      }

      checkOpenDialog();
      return false;
    }
  }
});

// Ajax Running
$(document).ajaxStart(function() {
  AjAX_RUNNING = true;
});